<template>
  <div class="relative">
    <button ref="trigger" type="button" class="flex items-center p-1 focus:outline-hidden" :title="`Filtrer ${heading}`" @click.stop="toggle">
      <svgicon name="chevron-down" size="xs" :class="hasSelection ? 'text-blue-500' : 'text-gray-400'" />
    </button>
    <Teleport to="body">
      <div
        v-if="open"
        ref="dropdown"
        class="fixed z-[200] w-48 overflow-hidden rounded-md border bg-white shadow-lg"
        :style="dropdownStyle"
        tabindex="-1"
        @click.stop
        @keydown.esc.stop.prevent="close"
      >
        <div class="p-2">
          <input
            ref="searchInput"
            v-model="search"
            type="text"
            class="w-full rounded-sm border border-gray-300 px-2 py-1 text-xs focus:border-blue-500 focus:outline-hidden"
            placeholder="Filtrer..."
          />
        </div>
        <ul class="max-h-60 overflow-y-auto">
          <li>
            <button
              type="button"
              class="flex w-full items-center px-3 py-1.5 text-left text-xs hover:bg-gray-100"
              :class="!hasSelection && 'font-semibold text-blue-600'"
              @click="clearSelection"
            >
              Alle
            </button>
          </li>
          <li v-for="option in filteredOptions" :key="option">
            <label class="flex w-full cursor-pointer items-center gap-2 px-3 py-1.5 text-xs hover:bg-gray-100">
              <input type="checkbox" class="rounded-sm border-gray-300" :checked="modelValue.includes(option)" @change="toggleOption(option)" />
              <span :class="modelValue.includes(option) && 'font-semibold text-blue-600'">{{ option }}</span>
            </label>
          </li>
        </ul>
      </div>
    </Teleport>
  </div>
</template>

<script>
export default {
  name: "FguTableColumnFilter",

  props: {
    heading: { type: String, required: true },
    options: { type: Array, default: () => [] },
    modelValue: { type: Array, default: () => [] },
  },

  emits: ["update:modelValue"],

  data() {
    return { open: false, search: "", dropdownStyle: {} };
  },

  computed: {
    hasSelection() {
      return this.modelValue.length > 0;
    },

    filteredOptions() {
      if (!this.search) return this.options;
      const q = this.search.toLowerCase();
      return this.options.filter((opt) => String(opt).toLowerCase().includes(q));
    },
  },

  beforeUnmount() {
    document.removeEventListener("click", this.closeOnClickOutside);
    window.removeEventListener("scroll", this.close, true);
    window.removeEventListener("resize", this.close);
  },

  methods: {
    toggle() {
      this.open ? this.close() : this.openDropdown();
    },

    openDropdown() {
      const rect = this.$refs.trigger.getBoundingClientRect();
      this.dropdownStyle = {
        top: `${rect.bottom + 4}px`,
        left: `${rect.left}px`,
      };
      this.open = true;
      document.addEventListener("click", this.closeOnClickOutside);
      window.addEventListener("scroll", this.close, true);
      window.addEventListener("resize", this.close);
      this.$nextTick(() => {
        try {
          this.$refs.searchInput?.focus({ preventScroll: true });
        } catch {
          // focus may be reclaimed by an ancestor focus trap (e.g. inside a Modal); ignore
        }
      });
    },

    close() {
      this.open = false;
      this.search = "";
      document.removeEventListener("click", this.closeOnClickOutside);
      window.removeEventListener("scroll", this.close, true);
      window.removeEventListener("resize", this.close);
    },

    closeOnClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target) && !this.$refs.trigger.contains(event.target)) {
        this.close();
      }
    },

    toggleOption(option) {
      const selected = this.modelValue.includes(option) ? this.modelValue.filter((v) => v !== option) : [...this.modelValue, option];
      this.$emit("update:modelValue", selected);
    },

    clearSelection() {
      this.$emit("update:modelValue", []);
    },
  },
};
</script>
